const abs = number => {
  return Math.abs(number);
};

const round = (number, digit = 0) => {
  if (Number.isInteger(digit) && digit > -1) {
    return digit ? Math.round(number * Math.pow(10, digit)) / Math.pow(10, digit) : Math.round(number);
  }
};

const ceil = (number, digit = 0) => {
  if (Number.isInteger(digit) && digit > -1) {
    return digit ? Math.ceil(number * Math.pow(10, digit)) / Math.pow(10, digit) : Math.ceil(number);
  }
};

const floor = (number, digit = 0) => {
  if (Number.isInteger(digit) && digit > -1) {
    return digit ? Math.floor(number * Math.pow(10, digit)) / Math.pow(10, digit) : Math.floor(number);
  }
};

const pow = (number, exponent = 1) => {
  return Math.pow(number, exponent);
};

const sqrt = number => {
  return Math.sqrt(number);
};

const log = (number, base = false) => {
  return Math.log(number) / (base ? Math.log(base) : 1);
};

const getRandom = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export {abs, round, ceil, floor, pow, sqrt, log, getRandom};
